/* eslint-disable no-unused-vars */
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import * as Styles from './DomainRegisterHandler.styles';
import useLocale from '@/hooks/useLocale';
import { initialStep, STEPS } from './DomainRegisterHandler.enum';
import { EnterDomainStep } from './components/EnterDomainStep';
import { FreeDomainStep } from './components/FreeDomainStep';
import HgLogoV2 from '@/media/logo/HgLogoV2';
import { IconArrow, IconButton } from 'gatorcomponents';
import { locale } from '@/utils/locale';
import { Redirect, useHistory, useLocation } from 'react-router';
import { GenericSuccess } from '@/components/FullWidthTemplate/GenericSuccess';
import {
  ATIVACAO_RESGATE_DOMINIO_GRATUITO,
  EXPERIENCIA_NEW_OFFER_SHARED_HOSTING,
} from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useDispatch, useSelector } from 'react-redux';
import { domainsActions, emailsActions } from '@/redux/modules';
import { HgProducts } from '@/components/SupportForms/SupportForms.types';
import { AVAILABILITY_STATUS } from '../ChangeTitanDomainHandler/ChangeTitanDomainHandler.enum';

const DomainRegisterHandler = () => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const [domainSld, setDomainSld] = useState('');
  const [domainTld, setDomainTld] = useState({ value: '.com', label: '.com' });
  const [domainIsUnavailable, setDomainIsUnavailable] = useState(false);
  const [radixIsUnavailable, setRadixIsUnavailable] = useState(false);
  const [checkedRadixOption, setCheckedRadixOption] = useState([
    { refuse: false },
    { refuse: false },
  ]);
  const [checkedTitanDomainStatus, setCheckedTitanDomainStatus] = useState(false);
  const [registeredDomains, setRegisteredDomains] = useState([]);
  const [isRedeeming, setIsRedeeming] = useState(false);
  const [userClickedContinue, setUserClickedContinue] = useState(false);

  const location = useLocation();
  const { recoverFreeDomainId } = location.state || {};
  const isTitanFlow = Boolean(recoverFreeDomainId);

  const {
    domainTlds, redeemAvailability, domainAvailability, checkProvider, domainRedeem,
  } = useSelector(state => state.newDomains);
  const { freeDomainRedeem: { loaded: titanFreeDomainRedeemDataLoaded, freeTlds: titanFreeDomainRedeemTlds, error: titanFreeDomainRedeemDataError } } = useSelector(state => state.emails);
  const { document } = useSelector(state => state.summary);
  const { loadingCheckDomainAvailability, changeTitanDomain: { status: changeTitanDomainStatus, tldSuggestions: titanTldSuggestions } } = useSelector(state => state.emails);
  const {
    domainRegister: domainRegisterLocale,
    routes: routesLocale,
  } = useLocale();
  const history = useHistory();
  const dispatch = useDispatch();

  const showRedeemFreeDomain = useFeatureIsOn(ATIVACAO_RESGATE_DOMINIO_GRATUITO);
  const showNewOfferSharedHosting = useFeatureIsOn(EXPERIENCIA_NEW_OFFER_SHARED_HOSTING);

  const currentRedeem = !!redeemAvailability.domains.length && redeemAvailability.domains[0];
  const currentRedeemRadix = !!redeemAvailability.domains.length
    && redeemAvailability.domains.filter((item, index) => index > 0 && item.hostingId === redeemAvailability.domains[0].hostingId);
  const numericDocument = document && document.replace(/\D/g, '');
  const isBrDomain = domainTld && domainTld.value.includes('.br');
  const isMPlan = currentRedeem && currentRedeem.packageId === HgProducts.PLANO_M;
  const isTurboPlan = currentRedeem && currentRedeem.packageId === HgProducts.HOSPEDAGEM_3;
  const newOfferSharedHostingEnabledCondition = currentRedeem && currentRedeem.packageId
    && (currentRedeem.packageId === HgProducts.HOSPEDAGEM_3 || currentRedeem.packageId === HgProducts.PLANO_M)
    && domainTld.value !== '.online'
    && domainTld.value !== '.store';

  const newOfferSharedHostingDisabledCondition = currentRedeem && currentRedeem.packageId
    && currentRedeem.packageId === HgProducts.HOSPEDAGEM_3
    && domainTld.value !== '.online';

  const currentRedeemHasRadix = showNewOfferSharedHosting
    ? newOfferSharedHostingEnabledCondition
    : newOfferSharedHostingDisabledCondition;

  const titanIsUnavailable = changeTitanDomainStatus !== AVAILABILITY_STATUS.DOMAIN_OK && checkedTitanDomainStatus && !loadingCheckDomainAvailability;

  const resetCurrentRadixDomainAvailability = useCallback(() => {
    dispatch(domainsActions.domainAvailability.resetCurrentRadix());
  }, [dispatch]);

  const dispatchRedeemDomain = useCallback(({ redeemDomainsList, callbackFunc, onErrorCallbackfunc }) => {
    if (isRedeeming) {
      return;
    }

    setIsRedeeming(true);
    setRegisteredDomains(redeemDomainsList.map(domain => `${domain.sld}${domain.tld}`));

    if (showNewOfferSharedHosting && currentStep === STEPS.FREE_DOMAIN_ONLINE && isTurboPlan) {
      callbackFunc();
      setIsRedeeming(false);
      return;
    }

    const wrappedCallback = () => {
      setIsRedeeming(false);
      if (callbackFunc) callbackFunc();
    };

    const wrappedErrorCallback = () => {
      setIsRedeeming(false);
      if (onErrorCallbackfunc) onErrorCallbackfunc();
    };

    dispatch(domainsActions.redeemDomain.request({
      redeemDomainsList,
      callbackFunc: wrappedCallback,
      onErrorCallbackfunc: wrappedErrorCallback,
    }));
  }, [dispatch, currentStep, showNewOfferSharedHosting, isTurboPlan, isRedeeming]);

  const handleRedeemDomain = useCallback(({ redeemRadix = false, onErrorCallbackfunc, radixTld = null }) => {
    const defaultDomainToRedeem = {
      domainCycle: 'one',
      redeemId: isTitanFlow ? recoverFreeDomainId : currentRedeem.id,
      related: [],
      type: 'redeem',
    };

    const createRadixDomain = (redeemId, tld) => ({
      ...defaultDomainToRedeem,
      redeemId,
      sld: domainSld,
      tld,
    });

    const redeemDomainsList = [
      {
        ...defaultDomainToRedeem,
        sld: domainSld,
        tld: domainTld.value,
      },
    ];

    const hasRadixAvailable = currentRedeemRadix && currentRedeemRadix.length > 0 && currentRedeemRadix[0] && currentRedeemRadix[0].id;
    if (isTurboPlan && hasRadixAvailable) {
      if (!showNewOfferSharedHosting && redeemRadix) {
        redeemDomainsList.push(createRadixDomain(currentRedeemRadix[0].id, '.online'));
      }

      if (showNewOfferSharedHosting) {
        if (!checkedRadixOption[0].refuse) {
          redeemDomainsList.push(createRadixDomain(currentRedeemRadix[0].id, '.online'));
        }

        if (!checkedRadixOption[1].refuse && currentRedeemRadix[1] && currentRedeemRadix[1].id) {
          redeemDomainsList.push(createRadixDomain(currentRedeemRadix[1].id, '.store'));
        }
      }
    }

    if (isMPlan && showNewOfferSharedHosting && hasRadixAvailable) {
      if (!checkedRadixOption[0].refuse) {
        redeemDomainsList.push(createRadixDomain(currentRedeemRadix[0].id, '.online'));
      }
    }

    const callbackFunc = () => {
      if (!showNewOfferSharedHosting) {
        setCurrentStep(STEPS.SUCCESS);
        return;
      }

      if (currentStep === STEPS.FREE_DOMAIN_ONLINE && currentRedeem.packageId === HgProducts.HOSPEDAGEM_3) {
        setCurrentStep(STEPS.FREE_DOMAIN_STORE);
        return;
      }

      setCurrentStep(STEPS.SUCCESS);
    };

    dispatchRedeemDomain({ redeemDomainsList, callbackFunc, onErrorCallbackfunc });
  }, [
    dispatchRedeemDomain,
    currentRedeem,
    domainSld,
    domainTld.value,
    currentRedeemRadix,
    isTitanFlow,
    recoverFreeDomainId,
    checkedRadixOption,
    showNewOfferSharedHosting,
    currentStep,
    isTurboPlan,
    isMPlan,
  ]);

  const executeAfterCheckDomainAvailability = useCallback(() => {
    const { currentDomain, currentRadix } = domainAvailability;

    const domainIsAvailable = domainAvailability.status === 'success' && currentDomain.isAvailable;
    const canRedirectToFreeRadixStep = !domainAvailability.loading && currentDomain.isAvailable;
    const radixIsAvailable = currentRadix && currentRadix.isAvailable;
    const isCheckingRadix = currentRadix && currentRadix.domain;

    if (isRedeeming) {
      return;
    }

    if (isTitanFlow
      && changeTitanDomainStatus === AVAILABILITY_STATUS.DOMAIN_OK
      && !domainRedeem.loading
      && currentStep !== STEPS.SUCCESS
      && checkedTitanDomainStatus) {
      const resetTitanDomainAvailability = () => {
        dispatch(emailsActions.checkDomainAvailabilityToTitan.reset());
        setCheckedTitanDomainStatus(false);
      };
      return handleRedeemDomain({ redeemRadix: false, onErrorCallbackfunc: resetTitanDomainAvailability });
    }

    if (
      !currentRedeemHasRadix
      && domainIsAvailable
      && !domainAvailability.loading
      && !domainRedeem.loading
      && currentStep !== STEPS.SUCCESS
    ) {
      handleRedeemDomain({ redeemRadix: false, radixTld: null });
    }

    if (
      (currentStep === STEPS.FREE_DOMAIN_ONLINE || currentStep === STEPS.FREE_DOMAIN_STORE)
      && isCheckingRadix
      && !domainAvailability.loading
      && !domainRedeem.loading
      && domainAvailability.status === 'success'
      && userClickedContinue
    ) {
      setUserClickedContinue(false);
      if (radixIsAvailable) {
        return handleRedeemDomain({ redeemRadix: true });
      }
      return handleRedeemDomain({ redeemRadix: false });
    }

    if (currentRedeemHasRadix && canRedirectToFreeRadixStep && currentStep !== STEPS.SUCCESS && currentStep !== STEPS.FREE_DOMAIN_STORE && currentStep !== STEPS.FREE_DOMAIN_ONLINE) {
      setCurrentStep(STEPS.FREE_DOMAIN_ONLINE);
    }
  }, [
    dispatch,
    handleRedeemDomain,
    domainRedeem.loading,
    currentRedeemHasRadix,
    domainAvailability,
    currentStep,
    isTitanFlow,
    changeTitanDomainStatus,
    checkedTitanDomainStatus,
    isRedeeming,
    userClickedContinue,
  ]);

  useEffect(() => {
    executeAfterCheckDomainAvailability();
  }, [executeAfterCheckDomainAvailability]);

  const executeVerifyBrDomain = useCallback(() => {
    if (isBrDomain && checkProvider.status === 'success' && checkProvider.available) {
      if (isTitanFlow) {
        dispatch(emailsActions.checkDomainAvailabilityToTitan.request({ domain: `${domainSld}.${domainTld.value.slice(1)}`, bringSuggestions: true, recoverFreeDomainId }));
        setCheckedTitanDomainStatus(true);
        return dispatch(domainsActions.checkProvider.reset());
      }
      dispatch(domainsActions.domainAvailability.request({
        sld: domainSld,
        tld: domainTld.value.slice(1),
      }));

      dispatch(domainsActions.checkProvider.reset());
    }
  }, [dispatch, isBrDomain, domainSld, domainTld.value, checkProvider.status, checkProvider.available, isTitanFlow, recoverFreeDomainId]);

  useEffect(() => {
    executeVerifyBrDomain();
  }, [executeVerifyBrDomain]);

  const clearStates = useCallback(() => {
    dispatch(domainsActions.domainAvailability.reset());
    dispatch(domainsActions.redeemDomain.reset());
    dispatch(domainsActions.checkProvider.reset());
    dispatch(domainsActions.redeemAvailability.reset());
    dispatch(emailsActions.checkDomainAvailabilityToTitan.reset());
    dispatch(emailsActions.getTitanDomainRedeemData.reset());
    setIsRedeeming(false);
    setUserClickedContinue(false);
  }, [dispatch]);

  const executeCleanUpOnSuccessStep = useCallback(() => {
    if (currentStep === STEPS.SUCCESS) {
      clearStates();
    }
  }, [currentStep, clearStates]);

  useEffect(() => () => {
    executeCleanUpOnSuccessStep();
  }, [executeCleanUpOnSuccessStep]);

  const getDefaultData = useCallback(() => {
    const firstHostWithRedeem = !!redeemAvailability.domains.length && redeemAvailability.domains[0];
    const productId = firstHostWithRedeem && firstHostWithRedeem.packageId;

    if (currentStep === initialStep && !redeemAvailability.loaded && !isTitanFlow) {
      dispatch(domainsActions.redeemAvailability.request());
    }
    if (!domainTlds.status && productId) {
      dispatch(domainsActions.domainTlds.request({ productId }));
    }
  }, [
    dispatch,
    currentStep,
    domainTlds.status,
    redeemAvailability.loaded,
    redeemAvailability.domains,
    isTitanFlow,
  ]);

  useEffect(() => {
    getDefaultData();
  }, [getDefaultData]);

  useEffect(() => {
    if (isTitanFlow && recoverFreeDomainId) {
      dispatch(emailsActions.getTitanDomainRedeemData.request({ recoverFreeDomainId }));
    }
    if (isTitanFlow && titanFreeDomainRedeemDataError) {
      history.push(routesLocale.emailsList);
      dispatch(emailsActions.getTitanDomainRedeemData.reset());
    }
  }, [isTitanFlow, recoverFreeDomainId, dispatch, titanFreeDomainRedeemDataError, history, routesLocale]);

  const enterDomainStepProps = useCallback(() => {
    const rightButtonLoading = redeemAvailability.loading || domainAvailability.loading || checkProvider.loading || domainRedeem.loading || loadingCheckDomainAvailability;
    const documentIsInvalid = isBrDomain
      && !checkProvider.loading
      && checkProvider.status
      && (checkProvider.status === 'failure' || !checkProvider.available);

    const resetDomainAvailabilityState = () => {
      dispatch(domainsActions.domainAvailability.reset());
    };

    const handleVerifyDocument = () => {
      dispatch(domainsActions.checkProvider.request({ numericDocument }));
    };

    const redirectToMyDataPage = () => {
      history.push(routesLocale.myData);
    };

    const rightButtonCta = () => {
      if (isTitanFlow) {
        if (isBrDomain && !checkProvider.status) {
          return handleVerifyDocument();
        }
        if (isBrDomain && documentIsInvalid) {
          return redirectToMyDataPage();
        }
        dispatch(emailsActions.checkDomainAvailabilityToTitan.request({ domain: `${domainSld}.${domainTld.value.slice(1)}`, bringSuggestions: true, recoverFreeDomainId }));
        return setCheckedTitanDomainStatus(true);
      }

      const checkDomainAvailability = () => {
        dispatch(domainsActions.domainAvailability.request({
          sld: domainSld,
          tld: domainTld.value.slice(1),
        }));
      };

      if (isBrDomain && !checkProvider.status) {
        return handleVerifyDocument();
      }
      if (isBrDomain && documentIsInvalid) {
        return redirectToMyDataPage();
      }
      if (!domainIsUnavailable && radixIsUnavailable) {
        return handleRedeemDomain({ redeemRadix: false, radixTld: null });
      }

      return checkDomainAvailability();
    };

    const mountRightButtonLabel = () => {
      if (isBrDomain && documentIsInvalid) {
        return domainRegisterLocale.inputDomainStep.myDataButtonLabel;
      }
      if (!domainIsUnavailable && radixIsUnavailable) {
        return domainRegisterLocale.continueButtonLabel;
      }
      if (currentRedeemHasRadix) {
        return domainRegisterLocale.continueButtonLabel;
      }
      if (showNewOfferSharedHosting && isTurboPlan && currentStep === STEPS.FREE_DOMAIN_ONLINE) {
        return domainRegisterLocale.continueButtonLabel;
      }

      return domainRegisterLocale.redemptDomain;
    };

    const rightButtonLabel = mountRightButtonLabel();

    const buttonsProps = {
      leftButton: {
        testId: 'enter-domain-left-button',
        label: domainRegisterLocale.returnButtonLabel,
        onClick: () => {
          if (isTitanFlow) {
            dispatch(emailsActions.getTitanDomainRedeemData.reset());
            dispatch(emailsActions.checkDomainAvailabilityToTitan.reset());
            history.push(routesLocale.emailsList);
            return;
          }
          history.push(routesLocale.domains);
        },
      },
      rightButton: {
        testId: 'enter-domain-right-button',
        label: rightButtonLabel,
        iconRight: <IconArrow direction="right" />,
        onClick: rightButtonCta,
        loading: rightButtonLoading,
        disabled: rightButtonLoading || !domainSld || !domainTld,
      },
    };

    return {
      domainSld,
      setDomainSld,
      domainTld,
      setDomainTld,
      domainIsUnavailable,
      setDomainIsUnavailable,
      radixIsUnavailable,
      setRadixIsUnavailable,
      resetDomainAvailabilityState,
      domainTlds,
      redeemAvailability,
      domainAvailability,
      rightButtonLoading,
      documentIsInvalid,
      buttonsProps,
      locales: domainRegisterLocale.inputDomainStep,
      isTitanFlow,
      titanFreeDomainRedeemDataLoaded,
      titanFreeDomainRedeemTlds,
      titanIsUnavailable,
      setCheckedTitanDomainStatus,
      titanTldSuggestions,
    };
  }, [
    dispatch,
    handleRedeemDomain,
    isBrDomain,
    currentRedeemHasRadix,
    numericDocument,
    checkProvider,
    domainRedeem.loading,
    domainAvailability,
    domainTlds,
    redeemAvailability,
    domainRegisterLocale,
    history,
    routesLocale,
    domainIsUnavailable,
    radixIsUnavailable,
    domainSld,
    domainTld,
    isTitanFlow,
    titanFreeDomainRedeemDataLoaded,
    titanFreeDomainRedeemTlds,
    titanIsUnavailable,
    loadingCheckDomainAvailability,
    titanTldSuggestions,
    recoverFreeDomainId,
    currentStep,
    isTurboPlan,
    showNewOfferSharedHosting,
  ]);

  const freeDomainStepProps = useCallback(() => {
    const leftButtonCta = () => {
      if (currentStep === STEPS.FREE_DOMAIN_STORE) {
        resetCurrentRadixDomainAvailability();
        setIsRedeeming(false);
        setUserClickedContinue(false);
        setCurrentStep(STEPS.FREE_DOMAIN_ONLINE);
        return;
      }
      clearStates();
      resetCurrentRadixDomainAvailability();
      setIsRedeeming(false);
      setUserClickedContinue(false);
      setCurrentStep(STEPS.ENTER_DOMAIN);
    };

    const buttonsProps = {
      leftButton: {
        label: domainRegisterLocale.returnButtonLabel,
        onClick: leftButtonCta,
        disabled: domainRedeem.loading || domainAvailability.loading,
        loading: domainRedeem.loading || domainAvailability.loading,
      },
      rightButton: {
        label: domainRegisterLocale.continueButton,
        iconRight: <IconArrow direction="right" />,
        loading: domainRedeem.loading || domainAvailability.loading,
      },
    };

    const locales = {
      ...domainRegisterLocale.freeDomainStep,
      title: domainRegisterLocale.freeDomainStep.title(currentRedeem.packageId),
      description: domainRegisterLocale.freeDomainStep.description(currentRedeem.packageId),
      subtitle: currentStep === STEPS.FREE_DOMAIN_ONLINE
        ? domainRegisterLocale.freeDomainStep.firstFreeDomain
        : domainRegisterLocale.freeDomainStep.secondFreeDomain,
    };

    return {
      locales,
      buttonsProps,
      domainSld,
      handleRedeemDomain,
      checkedRadixOption,
      setCheckedRadixOption,
      loadingRedeem: domainRedeem.loading,
      loadingDomainAvailability: domainAvailability.loading,
      currentRadix: domainAvailability.currentRadix,
      resetCurrentRadixDomainAvailability,
      tld: currentStep === STEPS.FREE_DOMAIN_ONLINE ? '.online' : '.store',
      isTurboPlan,
      currentStep,
      setUserClickedContinue,
    };
  }, [isTurboPlan, currentRedeem.packageId, domainRegisterLocale, domainRedeem, domainSld, checkedRadixOption, clearStates, handleRedeemDomain, domainAvailability.currentRadix, domainAvailability.loading, resetCurrentRadixDomainAvailability, currentStep]);

  const getSuccessStepProps = useCallback(() => {
    const buttonsProps = {
      rightButton: {
        testId: 'domain-register-right-button',
        label: isTitanFlow ? locale('title.v2.emails') : locale('title.v2.sitesPage'),
        iconRight: <IconArrow direction="right" />,
        onClick: () => (isTitanFlow ? history.push(routesLocale.emailsList) : history.push(routesLocale.sitesPage)),
      },
    };

    const locales = domainRegisterLocale.successStep.content({ domains: registeredDomains });

    return {
      locales: {
        title: locales.title,
        description: locales.description,
        infoList: locales.infoList,
        note: locales.renewalNotice,
      },
      buttonsProps,
      imageSrc: null,
      contentWidthFlexible: true,
      contentStartAligned: true,
    };
  }, [
    domainRegisterLocale,
    history,
    routesLocale,
    isTitanFlow,
    registeredDomains,
  ]);

  const handleGoBack = () => {
    history.goBack();
  };

  const renderStepRules = {
    [STEPS.ENTER_DOMAIN]: <EnterDomainStep {...enterDomainStepProps()} />,
    [STEPS.FREE_DOMAIN_ONLINE]: <FreeDomainStep {...freeDomainStepProps()} />,
    [STEPS.FREE_DOMAIN_STORE]: <FreeDomainStep {...freeDomainStepProps()} />,
    [STEPS.SUCCESS]: <GenericSuccess {...getSuccessStepProps()} />,
  };

  // If is titan flow just need the recoverFreeDomainId from redirect
  if ((!showRedeemFreeDomain || (redeemAvailability.loaded && !currentRedeem)) && !isTitanFlow) {
    return (<Redirect to={routesLocale.domains} />);
  }

  return (
    <Styles.Wrapper data-testid="domain-register-handler">

      <Styles.LogoRow>
        <HgLogoV2 newMenu />
        <IconButton
          testId="close-button"
          icon="IconClose"
          onClick={handleGoBack}
        />
      </Styles.LogoRow>

      <Styles.Container>
        {renderStepRules[currentStep]}
      </Styles.Container>
    </Styles.Wrapper>
  );
};

export default DomainRegisterHandler;
